import { Context } from '@leverege/plugin';
import P from '@leverege/promise';
import { Dialogs } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import BulkUpdateItem from "../view/BulkUpdateItem.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.imagine.actions.BulkUpdateAction');
const create = relationship => {
  const {
    blueprint,
    path
  } = relationship;
  return {
    id: `blueprint.action.${path}.BulkUpdateItems`,
    name: tf('name', {
      blueprintName: blueprint.name
    }),
    prepare: async cxt => {
      const targets = Context.getTargetsOfType(cxt, blueprint.type);
      const canAll = await P.mapLimit(targets, async target => {
        const delegate = DataSources.getActions(target);
        const can = await GlobalState.dispatch(delegate.canUpdate(GlobalState.get(), true));
        return can;
      }, {
        limit: 5
      });
      return canAll;
    },
    isPrepared: cxt => {
      const targets = Context.getTargetsOfType(cxt, blueprint.type);
      if (targets == null || targets.length < 2) {
        return true;
      }
      let canAll = true;
      targets.forEach(tgt => {
        const delegate = DataSources.getActions(tgt);
        const can = delegate?.canUpdate(GlobalState.get(), false) != null;
        if (can === false) {
          canAll = false;
        }
      });
      return canAll === true;
    },
    handles: cxt => {
      const targets = Context.getTargetsOfType(cxt, blueprint.type);
      if (targets == null || targets.length < 2) {
        return false;
      }
      let canAll = true;
      targets.forEach(tgt => {
        const delegate = DataSources.getActions(tgt);
        const can = delegate?.canUpdate(GlobalState.get(), false);
        if (can === false) {
          canAll = false;
        }
      });
      return canAll === true;
    },
    layout: {
      sort: 'item.edit2',
      sectionName: t('sectionName', {
        blueprintName: blueprint.name
      })
    },
    appearance: ({
      context,
      action
    }) => {
      const targets = Context.getTargetsOfType(context, blueprint.type);
      const count = targets.length;
      return {
        name: t('appearanceName', {
          count,
          blueprintName: blueprint.namePlural
        }),
        icon: tIcon('editIcon', 'fa fa-pencil fa-fw')
      };
    },
    perform: ({
      context
    }) => {
      const {
        clientProps: {
          delegate
        }
      } = context;
      Dialogs.show({
        component: BulkUpdateItem,
        props: {
          targets: Context.getTargetsOfType(context, blueprint.type),
          delegate,
          relationship
        }
      });
    }
  };
};
export default {
  create
};